import PT from 'prop-types';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useMediaQuery,
  CircularProgress,
  Pagination,
  TextField,
  Button,
  FormControl,
  Box,
  Select,
  MenuItem
} from '@mui/material';
import ExerciseCard from 'components/exerciseCard';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useDispatch } from 'react-redux';
import { fetchExerciseByCourseIdAsync } from 'store/actions';
import { baseURLs } from 'utils/baseURLs';

const CourseCard = ({ session, id, type }) => {
  const matches = useMediaQuery('(min-width:600px)');
  const [exercise, setExercise] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [exercisePerPage] = useState(10);
  const [age, setAge] = useState('');
  const navigate = useNavigate();
  const [authorized] = useState(true);
  const [accessCode, setAccessCode] = useState('');
  const [expanded, setExpanded] = useState(false);

  const fetchExercises = async iditem => {
    if (type !== 'T1234') {
      localStorage.setItem('courseIdselected', iditem);

      setLoading(true);
      // JG: CKey-63: append '&options[0][name]=modnameoptions[0][value]=kb' to filter api response to just kb modules
      // topics without kb modules will have am empty modules array 
      await dispatch(fetchExerciseByCourseIdAsync(baseURLs.core_course_get_contents + iditem +'&options[0][name]=modname&options[0][value]=kb'))
        .unwrap()
        .then(res => {
          if (Array.isArray(res)) {
            // JG: CKey-63: filter out topics that don't have kb modules in them
            setExercise(res.filter(item => item.modules.length > 0));
          } else {
            setExercise([]); // Fallback to an empty array if the response is not an array
          }
        })
        .catch(err => console.log(err));
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   const fetchAuthorization = async () => {
  //     const userId = userContext?.userData?.id || localStorage.getItem('userid');

  //     // const userId =
  //     //   userContext && userContext.userData
  //     //     ? userContext.userData.id
  //     //     : sessionStorage.getItem('userid');
  //     const res = await moodleAxios.get(`/course/activate_kbws.php?id=${id}&userid=${userId}`);
  //     if (res.data.status === 'Activation code is available') {
  //       setAuthorized(true);
  //     }
  //   };
  //   fetchAuthorization();
  // }, [id, userContext]);

  const indexOfLastPage = currentPage * exercisePerPage;
  const indexOfFirstPage = indexOfLastPage - exercisePerPage;
  const currentExercise = Array.isArray(exercise)
    ? exercise.slice(indexOfFirstPage, indexOfLastPage)
    : [];

  const paginate = e => {
    setCurrentPage(Number(e));
  };
  useEffect(() => {
    const activityInstance = sessionStorage.getItem('activityInstance');
    if (activityInstance == id) {
      setExpanded(true); // Expand Accordion if activityInstance exists and ID is 2019
    }
    fetchExercises(activityInstance);
  }, [id]);

  const handleChange = event => {
    navigate(`/courses/courses/${event.target.value.id}`, {
      state: {
        modules: event.target.value.modules,
        session: event.target.value.name,
        courseID: event.target.value.id,
        links: `${event.target.value.modules}-${event.target.value.id}`
      }
    });
    setAge(event.target.value);
  };
  const handleExpand = id => {
    setExpanded(prev => !prev); // Toggle expanded state
    fetchExercises(id); // Fetch exercises on expand
  };
  const onSubmit = async () => {
    // const res = await moodleAxios.post(
    //   `/course/activate_kbws.php?id=${id}&userid=${userContext.userData.id}&param=POST&activation_code=${accessCode}`
    // );
    // if (res.data.status === 'Success') {
    //   setAuthorized(true);
    //   setExpanded(true);
    // } else {
    //   alert('Access code is not valid');
    //   setAccessCode('');
    // }
  };

  return (
    <Accordion
      expanded={expanded}
      onChange={() => handleExpand(id)} // Handle change on accordion
      sx={{
        backgroundColor: '#ffffff !important',
        boxShadow: `0.3rem 0.3rem 0.5rem rgb(195 193 198 / 90%), -0.2rem -0.2rem 0.4rem rgb(195 193 198 / 90%) !important`,
        cursor: 'pointer !important',
        marginBottom: '20px !important',
        borderRadius: '10px !important'
      }}>
      <AccordionSummary
        sx={{
          padding: '15px !important',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100% !important',
          backgroundColor: '#ffffff !important',
          borderRadius: '25px !important'
        }}
        expandIcon={
          <ExpandMoreIcon
            sx={{ marginLeft: 'auto !important' }}
            fontSize={matches ? 'large' : 'medium'}
          />
        }>
        <Typography
          sx={{
            fontSize: matches ? '23px !important' : '15px !important',
            marginLeft: '20px !important',
            textShadow:
              '3px 3px 8px rgb(163,177,198,.7), -3px -3px 8px rgba(255,255,255, 1) !important',
            fontWeight: 'bold !important',
            textTransform: 'uppercase'
          }}
          color="#585858 !important">
          {session}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ paddingTop: '5px !important' }}>
        {!loading && !authorized && (
          <div>
            <Typography>
              <b>First Time Accessing your course?</b>
            </Typography>
            <Typography color="secondary" style={{ fontSize: '15px' }}>
              Before you can access any content in this course you must provide your access code.
              You can find this in the card enclosed in your textbook purchase or an email from
              Paradigm Education Solutions.
            </Typography>
            <form style={{ width: '100%', textAlign: 'center' }}>
              <Typography>
                <b>Access Code</b>
              </Typography>
              <TextField
                value={accessCode}
                onChange={e => setAccessCode(e.target.value)}
                type="text"
                variant="outlined"
              />
              <br />
              <Button
                variant="contained"
                style={{ backgroundColor: 'green', color: 'white', marginTop: '10px' }}
                onClick={onSubmit}>
                Access Course
              </Button>
            </form>
          </div>
        )}
        {loading && exercise.length === 0 && (
          <div style={{ minHeight: '100px', display: 'flex', justifyContent: 'center' }}>
            <CircularProgress style={{ color: 'grey' }} />
          </div>
        )}
        {type === 'T1234' && (
          <h4 style={{ textAlign: 'center', color: 'red' }}>No data is present</h4>
        )}
        {authorized &&
          exercise.length > 0 &&
          currentExercise.map(
            (excise, i) =>
              excise.visible == 1 && (
                <ExerciseCard
                  id={excise?.id}
                  courseID={id}
                  modules={excise?.modules}
                  key={i}
                  session={excise?.name}
                />
              )
          )}
        {authorized && exercise.length > exercisePerPage && (
          <>
            <Pagination
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
              hideNextButton
              hidePrevButton
              page={currentPage}
              count={Math.ceil(exercise.length / exercisePerPage) || 1} // Ensure count is at least 1
              onClick={e => paginate(e.target.textContent)}
              color="secondary"
            />
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Typography sx={{ fontSize: 'small' }}>Jump To Session: </Typography>
              <FormControl variant="filled" sx={{ minWidth: 100 }}>
                <Select
                  sx={{ mx: 1 }}
                  value={age}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                  onChange={handleChange}>
                  {exercise.length > 4 &&
                    exercise.map(curr => (
                      <MenuItem key={curr.id} value={curr}>
                        {curr.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Box>
          </>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

CourseCard.propTypes = {
  session: PT.string.isRequired,
  id: PT.number.isRequired,
  type: PT.string.isRequired
};

export default CourseCard;
